const clients = [
  "Property Owners",
  "Developers",
  "Investors",
  "Corporate Clients",
  "Architects",
  "Banks",
  "Legal Experts",
];

export default function TrustedByBar() {
  return (
    <section className="border-y border-background-300/40 bg-background-100/60 py-6">
      <div className="container mx-auto flex flex-wrap items-center justify-center gap-x-8 gap-y-3 px-4 lg:px-8">
        <span className="text-xs font-semibold tracking-[0.25em] text-primary-500 uppercase">
          Trusted by
        </span>
        {clients.map((client) => (
          <span
            key={client}
            className="text-sm text-foreground-600"
          >
            {client}
          </span>
        ))}
      </div>
    </section>
  );
}